<template>
  <section class="col-12 col-xl-12 col-md-12 box-col-12">
    <div class="card item-education-wraper">
      <div class="card-header">{{ $t('riwayat_pendidikan') }}</div>

      <div class="card-body">
        <ItemPendidikan v-for="(item,idx) in dataEducations" :key="idx" :item="item"></ItemPendidikan>
        <!-- <ItemPendidikan></ItemPendidikan>
        <ItemPendidikan></ItemPendidikan>
        <ItemPendidikan></ItemPendidikan>
        <ItemPendidikan></ItemPendidikan> -->
      </div>

      <div class="card-action">
        <button v-b-modal.education class="btn btn-block btn-action"><i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>Add {{ $t('riwayat_pendidikan') }}</button>
      </div>
    </div>

    <!-- Vertically centered Modal Component -->
    <b-modal
      id="education"
      size="lg"
      width="100%"
      centered
      :title="`Add ${$t('riwayat_pendidikan')}`"
      ok-title="Save"
      @ok="handleSubmit"
      cancel-title="Cancel"
      class="theme-modal"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('gelar_pendidikan') }}</h6>
            <input
              class="form-control"
              v-model="form.gelar"
              :placeholder="$t('gelar_pendidikan')"
            />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tingkat_pendidikan') }}</h6>
            <multiselect
              v-model="form.level"
              :options="dataSource.level"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              :placeholder="$t('tingkat_pendidikan')"
            ></multiselect>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('departemen_education') }}</h6>
            <input
              class="form-control"
              v-model="form.jurusan"
              :placeholder="$t('departemen_education')"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('nama_institusi') }}</h6>
            <input
              class="form-control"
              v-model="form.nama_sekolah"
              :placeholder="$t('nama_institusi')"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('provinsi') }}</h6>
            <input
              class="form-control"
              v-model="form.provinces"
              :placeholder="$t('provinsi')"
            />
          </div>
        </div>


        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tanggal_mulai') }}</h6>
            <datepicker input-class="datepicker-here form-control digits" v-model="dateMulai" :format="'dd/MM/yyyy'" ></datepicker>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tanggal_selesai') }}</h6>
            <datepicker input-class="datepicker-here form-control digits" v-model="dateEnd" :format="'dd/MM/yyyy'" ></datepicker>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">Grade Point Average</h6>
            <input
              class="form-control"
              v-model="form.ip"
              placeholder="GPA"
            />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('keterampilan_terkait_pendidikan') }}</h6>
            <b-form-tags v-model="form.keterampilan" :placeholder="$t('keterampilan_terkait_pendidikan')"></b-form-tags>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-0">
            <h6 class="form-label">{{ $t('edukasi_deskripsi') }}</h6>
            <textarea
              class="form-control"
              rows="4"
              v-model="form.deskripsi"
              :placeholder="$t('edukasi_deskripsi')"
            ></textarea>
          </div>
        </div>

      </div>
    </b-modal>
  </section>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vuejs-datepicker';
  import { formatDate } from '../../_helpers';
  import { getDataProvinces } from "../../_services/data.service";
  import ItemPendidikan from "./item/ItemPendidikan.vue";
  import { getDataEducation,submitDataEducation } from "../../_services/profile.service";
  export default {
    components: {
      ItemPendidikan,
      Multiselect,
      Datepicker
    },
    data() {
      return {
        dataSource :{
          level: [
            {
              name: 'D1 - Diploma I',
              value: 'D1'
            },
            {
              name: 'D2 - Diploma II',
              value: 'D2'
            },
            {
              name: 'D3 - Diploma III',
              value: 'D3'
            },
            {
              name: 'D4 - Diploma IV',
              value: 'D4'
            },
            {
              name: 'S1 - Sarjana',
              value: 'S1'
            },
            {
              name: 'S2 - Pasca Sarjana',
              value: 'S2'
            },
            {
              name: 'S3 - Doktor',
              value: 'S3'
            },
            {
              name: 'MA - Madrasah Aliyah',
              value: 'MA'
            },
            {
              name: 'SMA - Sekolah Menengah Atas',
              value: 'MA'
            },
            {
              name: 'SM - Sekolah Menengah Kejuruan',
              value: 'MA'
            },
          ],
          provinces : []
        },
        dataEducations: [],
        form : {
          id: null,
          id_user : this.$route.query.id_user,
          gelar: '',
          level : '',
          jurusan : '',
          nama_sekolah : '',
          lokasi : '',
          tanggal_mulai : '',
          tanggal_selesai : '',
          ip : '',
          keterampilan : [],
          deskripsi : ''
        }
      };
    },
    computed:{
      dateMulai : {
        get(){
          return this.form.tanggal_mulai;
        },
        async set(val){
          this.form.tanggal_mulai = await formatDate(val);
        },
      },
      dateEnd : {
        get(){
          return this.form.tanggal_selesai;
        },
        async set(val){
          this.form.tanggal_selesai = await formatDate(val);
        },
      }
    },
    mounted(){
      this.fetchDataProvinces();
      this.fetchDataEducation();
      let lang = localStorage.getItem('currentLanguage') ?  localStorage.getItem('currentLanguage') : process.env.VUE_APP_LANG;
      if (lang == 'en') {
        this.dataSource = {
          level: [
            {
              name: 'Associate degree',
              value: 'AD'
            },
            {
              name: "Bachelor's degree",
              value: 'BD'
            },
            {
              name: "Master's degree",
              value: 'MD'
            },
            {
              name: 'Doctoral degree',
              value: 'DD'
            },
            {
              name: 'Senior High School',
              value: 'SMA'
            },
            {
              name: 'Junior High School',
              value: 'SMP'
            },
          ],
          provinces : []
        };
      }
      
    },
    methods : {
      async fetchDataProvinces(){
        await getDataProvinces().then(res => {
          this.dataSource.provinces = res;
        });
      },
      async fetchDataEducation(){
        this.dataEducations = await getDataEducation(this.$route.query.id_user);
      },
      async handleSubmit(){
        await submitDataEducation(this.form);
        this.fetchDataEducation();
      }
    }
  };
</script>

<style lang="scss">
.item-education-wraper {
  padding: 0;
  .card-header {
    padding: 18px 25px !important;
    font-size: 1.1rem;
    font-weight: 500;
  }
  .item {
    flex-direction: column;
    h3 {
      font-size: 0.9rem;
      font-weight: 500;
    }
    h5 {
      font-size: 0.9rem;
      font-weight: 400;
    }
  }
  .card-body {
    padding: 18px 25px !important;
    gap: 1rem;

    max-height: 530px;
    height: 530px;
    overflow: auto;
    flex-direction: column;
  }

  .item-personal {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-address {
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-minat {
    -ms-flex: 0 0 30%;
    -webkit-box-flex: 0;
    flex: 0 0 30%;
    max-width: 30%;
    padding: 18px 25px;
    display: flex;
    flex-direction: column;

    .item-hobie {
      flex: 1;
      h3 {
        font-size: 0.9rem;
        font-weight: 500;
      }

      .list-item {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        .rounded {
          padding: 0.2rem 1rem;
          background: var(--theme-deafult);
          color: var(--theme-font);
          font-size: 0.7rem;
          border-radius: 1rem !important;
        }
      }
    }
  }

  .btn-action{
    border-top: 1px solid #E9ECEF;
    font-weight: 600;
    padding-top: .7rem;
    padding-bottom: .7rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    color: #1d1e26;
    .fa{
      font-size: 1rem;
    }
  }

  .card-body {
    display: flex;
    .d-flex {
      width: 100%;
    }
  }
}
</style>
